export const setIsFeedbackFormsEnabled = value => ({
    type: 'FEEDBACK_FORMS_ENABLED',
    value
});

export const setDataCollectionDelay = value => ({
    type: 'DATA_COLLECTION_DELAY',
    value
});

export const setMockBrazeContentCards = value => ({
    type: 'MOCK_BRAZE_CONTENT_CARDS',
    value
});